import api from './base'

export async function askFaqBot(data) {
	try {
		const res = await api.post('/faq/ask', data)
		return res.data
	} catch (error) {
		console.error('error fetching faq answer', error)
	}
}
